export const METHOD_STEPS = [
  {
    num: "01",
    title: "Diagnóstico",
    desc: "Entender cenário, dados, limitações e oportunidades antes de propor ações.",
    extra: "Leitura do negócio, ativos, demanda, técnica, conteúdo e mensuração.",
  },
  {
    num: "02",
    title: "Estratégia",
    desc: "Definir direção, prioridades e critérios para transformar análise em plano.",
    extra: "Roadmap orientado por impacto, esforço, dependências e risco.",
  },
  {
    num: "03",
    title: "Execução",
    desc: "Implementar com clareza de responsabilidade, sequência e padrão de qualidade.",
    extra: "Ações técnicas, editoriais e de mensuração com validação objetiva.",
  },
  {
    num: "04",
    title: "Monitoramento",
    desc: "Observar evolução, desvios e sinais que exigem nova investigação.",
    extra: "Indicadores por tema, página, saúde técnica, jornada e conversão.",
  },
  {
    num: "05",
    title: "Escala",
    desc: "Consolidar aprendizados e ampliar o que demonstra utilidade e consistência.",
    extra: "Novos ciclos com hipóteses melhores, menor desperdício e mais maturidade.",
  },
];

export const GOVERNANCE = [
  { num: "01", title: "Decisão", desc: "Critério, prioridade, responsável e prazo de revisão." },
  { num: "02", title: "Implementação", desc: "Escopo, acesso, dependência técnica e definição de concluído." },
  { num: "03", title: "Validação", desc: "Teste, evidência, período e registro do que mudou." },
];

export const CADENCE = [
  "Registro de linha de base",
  "Atualização de execução",
  "Leitura contextual dos indicadores",
  "Revisão do próximo ciclo",
];

export const REPORTS = [
  { title: "Observação", desc: "Dados, período, recorte e comparação adequada." },
  { title: "Execução", desc: "Mudanças concluídas, pendências e dependências." },
  { title: "Decisão", desc: "Hipótese atual, prioridade e próximo teste." },
];
